import * as c from '../constants';

export const currentMarker = (marker) => ({
    type: c.CURRENT_MARKER,
    marker
})


const setMarkers = (data) => ({
    type: c.GET_FITTER_MARKERS,
    data
})

export const getFitters = () => {
    return (dispatch, getState, { graph }) => {
        graph.get('', `{fitters {id, first,last,addr1,city,email,lat,long}, location {ip_no, country_long, latitude, longitude}}`, dispatch)
            .then(response => {
                const { fitters, location } = response.data;
                const markers = fitters.map(item => {
                    return {
                        ...item,
                        position: { lat: parseFloat(item.lat), lng: parseFloat(item.long) }
                    }
                })     
                dispatch(setMarkers(markers));          
                dispatch({
                    type: c.GET_FITTERS,
                    data: fitters
                })
                dispatch({
                    type: c.GET_CURRENT_LOCATION,
                    data: location
                })
            })
        // api.get('/fitterlocator')
        //     .then(response => {
        //         const { fitters } = response;
        //         dispatch({
        //             type: c.GET_FITTERS,
        //             data: fitters
        //         });
        //     })
    }
}


// WEBPACK FOOTER //
// ./src/fitters-locator/actions/index.js